module.exports = __webpack_public_path__ + "static/media/portfolio12.ca837b98.png";